import { platformNewsItemFlags, platformNewsItemSections } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    header: {
        label: "Название",
        inputProps: { name: "header" },
        validators: [requiredField],
        required: true,
    },
    text: {
        // field
        label: "Текст новости",
        inputProps: { name: "text" },
    },
    section: {
        // select
        label: "Раздел",
        inputProps: { name: "section" },
        options: platformNewsItemSections,
    },
    flags: {
        // flags
        label: "Опции",
        inputProps: { name: "flags" },
        flags: platformNewsItemFlags,
    },
    id: {},
    fileIds: {},
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
